import { createAction } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { Company } from '../../types/amr-pipeline/models/Company';

const request = createAction(
    'entities/arrangers/REQUEST',
    resolve => (requestState: RequestState) => resolve({ requestState }),
);

const response = createAction(
    'entities/arrangers/RESPONSE',
    resolve => (requestState: RequestState, arrangers: Company[]) => resolve({ requestState, arrangers }),
);

export const arrangersActions = { request, response };
